import domain from './domain';

// Reset workspace user
export const resetWorkspaceUser = domain.createEvent('resetWorkspaceUser');

